import React from 'react';
import { CustomGraph } from '../../../../components';
import { MatrixColumn, MatrixHorizontalBar, MatrixTable } from '../MatrixResult';
import SemanticScaleTable from '../SemanticScaleResult';
import ResultsTable from './ResultsTable';
import { getMappedData, getYDomain } from '../QuestionDataMappers';

const ChartRenderer = ({ question, plotType }) => {
  const { questionType, responseFormat } = question;

  // 1. Matrix Question rendering
  if (questionType === 'structured' && responseFormat === 'matrix') {
    if (plotType === 'column') {
      return <MatrixColumn question={question} />;
    }
    if (plotType === 'horizontalBar') {
      return <MatrixHorizontalBar question={question} />;
    }
    if (plotType === 'table') {
      return <MatrixTable question={question} />;
    }
  }

  // 2. Semantic Differential or Points Question table rendering
  if (plotType === 'table' && (responseFormat === 'semantic_differential' || responseFormat === 'points')) {
    return <SemanticScaleTable question={question} />;
  }

  // 3. Generic table rendering
  if (plotType === 'table') {
    return <ResultsTable question={question} />;
  }

  const isSimpleChoice =
    questionType !== 'open' &&
    !['matrix', 'semantic_differential', 'points', 'preference_order'].includes(responseFormat);
  const isPreferenceOrder = responseFormat === 'preference_order';
  const isPoints = responseFormat === 'points';
  const hidePieLegend = isSimpleChoice || isPreferenceOrder || isPoints;

  // 4. Standard Recharts rendering via CustomGraph
  return (
    <CustomGraph
      customizedLabel
      chartType={plotType}
      title={false}
      data={getMappedData(question)}
      pieLegend={hidePieLegend ? false : { layout: 'vertical', verticalAlign: 'middle', align: 'right' }}
      activeAnimation={false}
      yDomain={getYDomain(question)}
      useRawValues={['points', 'semantic_differential', 'preference_order'].includes(responseFormat)}
    />
  );
};

export default ChartRenderer;
